import { forwardRef, type SVGProps } from "react";

// Custom Cow icon matching Lucide's stroke style (24x24, stroke-width 2, currentColor)
export const CowIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Ears */}
    <path d="M5 7c-1.5 0-3 1-3 3 0 1.5 1 2.5 2.5 2.5" />
    <path d="M19 7c1.5 0 3 1 3 3 0 1.5-1 2.5-2.5 2.5" />
    {/* Head */}
    <path d="M5 10c0-3.5 3-6 7-6s7 2.5 7 6v3a5 5 0 0 1-5 5h-4a5 5 0 0 1-5-5z" />
    {/* Horns */}
    <path d="M7 5c-.5-1-1.5-1.5-2.5-1.5" />
    <path d="M17 5c.5-1 1.5-1.5 2.5-1.5" />
    {/* Eyes */}
    <circle cx="9" cy="10" r=".5" fill="currentColor" />
    <circle cx="15" cy="10" r=".5" fill="currentColor" />
    {/* Snout */}
    <ellipse cx="12" cy="14.5" rx="3" ry="2.5" />
    <circle cx="10.5" cy="14.5" r=".5" fill="currentColor" />
    <circle cx="13.5" cy="14.5" r=".5" fill="currentColor" />
  </svg>
));

CowIcon.displayName = "CowIcon";

export default CowIcon;
